import React, { useState, useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Contacto.css';
import logoMG from '../../assets/logo/logo-mg.png';
import heroBg from '../../assets/contacto/contacto-hero.jpg';

const EMAILJS_SERVICE_ID  = 'service_s6sfxtc';
const EMAILJS_TEMPLATE_ID = 'template_5khx68k';
const EMAILJS_PUBLIC_KEY  = 'xnZrJ12HX7h6n5poB';
const SHEETS_URL          = 'https://script.google.com/macros/s/AKfycbx_bp5F-qX0xcyhZL7W13ZDWMeRHTjU5gqvckF96ib-lOuy16Hl959dGbs9tYsvsca1uQ/exec';
const COOLDOWN_MS         = 24 * 60 * 60 * 1000;
const LS_KEY              = 'mg_form_last_sent';

const FRASES = [
  'Un lugar para deportistas',
  'Un lugar para crecer',
  'Un lugar para técnicos',
  'Un lugar para aprender',
  'Un lugar para familias',
  'Un lugar para confiar',
];

const SERVICIOS = [
  'Evaluación Psicológica',
  'Acompañamiento Deportivo',
  'Charlas',
  'Talleres',
  'Coaching Deportivo',
  'Coaching Empresas',
];

const DEPORTES = [
  'Fútbol','Tenis','Basketball','Hockey','Natación',
  'Atletismo','Volleyball','Rugby','Boxeo','Ciclismo',
  'Golf','Padel','Otro',
];

const PAISES = [
  'Chile','Argentina','Colombia','Perú','Brasil',
  'México','Uruguay','Ecuador','Bolivia','Paraguay',
  'Venezuela','España','Estados Unidos','Otro',
];

const WHATSAPP_URL = 'https://api.whatsapp.com/send/?phone=56962487459&text=Hola%2C%20me%20interesa%20saber%20m%C3%A1s%20sobre%20MG%20Profesionales&type=phone_number&app_absent=0';
const MAP_EMBED    = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.9!2d-70.6103!3d-33.4073!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf5b6e9a3b7f%3A0x0!2sAv.%20Vitacura%203568%2C%20Vitacura%2C%20Santiago%2C%20Chile!5e0!3m2!1ses!2scl!4v1680000000000!5m2!1ses!2scl';

const INITIAL_FORM = {
  nombre:'', apellido:'', edad:'', email:'', telefono:'',
  pais:'', ciudad:'', deporte:'', deporteOtro:'', servicio:'', mensaje:'',
};

const Contacto = () => {
  const [fraseIdx, setFraseIdx] = useState(0);
  const [fadeIn,   setFadeIn]   = useState(true);
  const [sending,  setSending]  = useState(false);
  const [status,   setStatus]   = useState(null);
  const [form,     setForm]     = useState(INITIAL_FORM);
  const [blocked,  setBlocked]  = useState(false);
  const formRef = useRef(null);

  /* Rotación de frases */
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeIn(false);
      setTimeout(() => { setFraseIdx(i => (i + 1) % FRASES.length); setFadeIn(true); }, 400);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  /* Verificar cooldown al cargar */
  useEffect(() => {
    const last = localStorage.getItem(LS_KEY);
    if (last && Date.now() - parseInt(last, 10) < COOLDOWN_MS) {
      setBlocked(true);
    }
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setSending(true);
    setStatus(null);

    const deporteFinal = form.deporte === 'Otro' ? form.deporteOtro : form.deporte;
    const payload = {
      nombre:   form.nombre,
      apellido: form.apellido,
      edad:     form.edad,
      email:    form.email,
      telefono: form.telefono,
      pais:     form.pais,
      ciudad:   form.ciudad,
      deporte:  deporteFinal,
      servicio: form.servicio,
      mensaje:  form.mensaje,
    };

    try {
      await Promise.all([
        emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, payload, EMAILJS_PUBLIC_KEY),
        fetch(SHEETS_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }),
      ]);
      setStatus('ok');
      setForm(INITIAL_FORM);
      localStorage.setItem(LS_KEY, Date.now().toString());
      setBlocked(true);
    } catch {
      setStatus('error');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contacto-page">

      {/* ── HERO ── */}
      <div className="contacto-hero" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="contacto-hero__overlay" />
        <p className={`contacto-hero__frase ${fadeIn ? 'visible' : ''}`}>{FRASES[fraseIdx]}</p>
      </div>

      <section className="contacto-section">

        {/* ── Columna izquierda ── */}
        <div className="contacto-info">
          <div className="contacto-logo-wrap">
            <img src={logoMG} alt="MG Profesionales" className="contacto-logo" />
          </div>
          <p className="contacto-tagline">ACTIVA TU POTENCIAL</p>

          <div className="contacto-data">
            <div className="contacto-data__item">
              <span className="contacto-data__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.22 2.18 2 2 0 012.2 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.72 6.72l1.28-.54a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                </svg>
              </span>
              <div>
                <p className="contacto-data__label">Teléfono / WhatsApp</p>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="contacto-data__value">+56 9 6248 7459</a>
              </div>
            </div>
            <div className="contacto-data__item">
              <span className="contacto-data__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </span>
              <div>
                <p className="contacto-data__label">Correo electrónico</p>
                <a href="mailto:info@mgprofesionales.cl" className="contacto-data__value">info@mgprofesionales.cl</a>
              </div>
            </div>
            <div className="contacto-data__item">
              <span className="contacto-data__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </span>
              <div>
                <p className="contacto-data__label">Dirección</p>
                <p className="contacto-data__value contacto-data__value--text">
                  Av. Vitacura 3568, Vitacura<br />Santiago, Chile
                </p>
              </div>
            </div>
          </div>

          <div className="contacto-map">
            <iframe title="Ubicación MG Profesionales" src={MAP_EMBED}
              width="100%" height="200" style={{ border: 0 }}
              allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          </div>

          <div className="contacto-socials">
            <a href="https://www.instagram.com/mgprofesionales" target="_blank" rel="noopener noreferrer" className="contacto-social" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
            <a href="https://www.linkedin.com/in/mg-profesionales-programa-mente-ganadora-%F0%9F%A7%A0-452b31354/" target="_blank" rel="noopener noreferrer" className="contacto-social" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
            </a>
            <a href="https://www.youtube.com/@Programamenteganadora" target="_blank" rel="noopener noreferrer" className="contacto-social" aria-label="YouTube">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/></svg>
            </a>
          </div>
        </div>

        {/* ── Columna derecha ── */}
        <div className="contacto-form-wrap">
          <h2 className="contacto-form-title">Escríbenos</h2>
          <p className="contacto-form-subtitle">Completa el formulario y te contactaremos a la brevedad.</p>

          {/* Panel de bloqueo o formulario */}
          {blocked ? (
            <div className="cf-blocked">
              <span className="cf-blocked__icon">🔒</span>
              <div>
                <p className="cf-blocked__title">Ya enviaste tu consulta</p>
                <p className="cf-blocked__text">
                  Solo se permite un envío por día. Si tienes urgencia escríbenos directamente por WhatsApp.
                </p>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="cf-blocked__wa">
                  Ir a WhatsApp →
                </a>
              </div>
            </div>
          ) : (
            <form ref={formRef} className="contacto-form" onSubmit={handleSubmit}>

              <div className="cf-row">
                <div className="cf-field">
                  <label className="cf-label">Nombre <span className="cf-required">*</span></label>
                  <input className="cf-input" type="text" name="nombre" placeholder="Tu nombre"
                    value={form.nombre} onChange={handleChange} required />
                </div>
                <div className="cf-field">
                  <label className="cf-label">Apellido <span className="cf-required">*</span></label>
                  <input className="cf-input" type="text" name="apellido" placeholder="Tu apellido"
                    value={form.apellido} onChange={handleChange} required />
                </div>
              </div>

              <div className="cf-row">
                <div className="cf-field">
                  <label className="cf-label">Correo <span className="cf-required">*</span></label>
                  <input className="cf-input" type="email" name="email" placeholder="tu@correo.com"
                    value={form.email} onChange={handleChange} required />
                </div>
                <div className="cf-field">
                  <label className="cf-label">Teléfono <span className="cf-required">*</span></label>
                  <input className="cf-input" type="tel" name="telefono" placeholder="+56 9 1234 5678"
                    value={form.telefono} onChange={handleChange} required />
                </div>
              </div>

              <div className="cf-row">
                <div className="cf-field">
                  <label className="cf-label">Edad <span className="cf-required">*</span></label>
                  <input className="cf-input" type="number" name="edad" placeholder="Tu edad"
                    min="5" max="99" value={form.edad} onChange={handleChange} required />
                </div>
                <div className="cf-field">
                  <label className="cf-label">País <span className="cf-required">*</span></label>
                  <select className="cf-input cf-select" name="pais" value={form.pais}
                    onChange={handleChange} required>
                    <option value="" disabled>Selecciona tu país</option>
                    {PAISES.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
              </div>

              <div className="cf-field cf-field--full">
                <label className="cf-label">Ciudad <span className="cf-required">*</span></label>
                <input className="cf-input" type="text" name="ciudad" placeholder="Tu ciudad"
                  value={form.ciudad} onChange={handleChange} required />
              </div>

              <div className="cf-field cf-field--full">
                <label className="cf-label">Deporte <span className="cf-required">*</span></label>
                <select className="cf-input cf-select" name="deporte" value={form.deporte}
                  onChange={handleChange} required>
                  <option value="" disabled>Selecciona tu deporte</option>
                  {DEPORTES.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
              </div>

              {form.deporte === 'Otro' && (
                <div className="cf-field cf-field--full cf-field--animated">
                  <label className="cf-label">¿Cuál deporte? <span className="cf-required">*</span></label>
                  <input className="cf-input" type="text" name="deporteOtro"
                    placeholder="Escribe tu deporte" value={form.deporteOtro}
                    onChange={handleChange} required />
                </div>
              )}

              <div className="cf-field cf-field--full">
                <label className="cf-label">Servicio de interés <span className="cf-required">*</span></label>
                <select className="cf-input cf-select" name="servicio" value={form.servicio}
                  onChange={handleChange} required>
                  <option value="" disabled>Selecciona un servicio</option>
                  {SERVICIOS.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>

              <div className="cf-field cf-field--full">
                <label className="cf-label">Mensaje <span className="cf-optional">(opcional)</span></label>
                <textarea className="cf-input cf-textarea" name="mensaje"
                  placeholder="Cuéntanos más sobre lo que necesitas..."
                  value={form.mensaje} onChange={handleChange} rows={4} />
              </div>

              <button type="submit" className="cf-submit" disabled={sending}>
                {sending ? 'Enviando...' : 'Enviar mensaje'}
              </button>

              {status === 'ok' && (
                <p className="cf-feedback cf-feedback--ok">
                  ✓ Mensaje enviado correctamente. Te contactaremos pronto.
                </p>
              )}
              {status === 'error' && (
                <p className="cf-feedback cf-feedback--error">
                  × Hubo un error al enviar. Inténtalo de nuevo o escríbenos directamente.
                </p>
              )}

            </form>
          )}

        </div>
      </section>
    </div>
  );
};

export default Contacto;
